import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./Pages/Home.tsx";
import LoginPage from "./Pages/LoginPage.tsx";
import Eventi from "./Pages/EventiPage.tsx";
import Cantieri from "./Pages/CantieriPage.tsx";
import Clienti from "./Pages/ClientiPage.tsx";
import Contratti from "./Pages/ContrattiPage.tsx";
import CalendarioPage from "./Pages/CalendarioPage.tsx";
import CreateEditPage from "./Pages/CreateEditPage.tsx";
import Unauthorized from "./Pages/Unauthorized.tsx";
import PrivateRoute from "./Pages/PrivateRoute.tsx";
import AlertProvider from "./Components/Alert.tsx";
import ResetPassword from "./Pages/ResetPassword.tsx";
import Impostazioni from "./Pages/Impostazioni.tsx";
import ScadenziarioPage from "./Pages/ScadenziarioPage.tsx";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "./Redux/Store/index.ts";
import { handleRefreshToken } from "./Redux/Actions.tsx";

function App() {
  const { refreshToken, profilo } = useSelector((state: RootState) => state.login);
  const dispatch: AppDispatch = useDispatch();
  const refresh = async () => {
    if (refreshToken && profilo) {
      const payload = { email: profilo.email, refreshToken: refreshToken };
      console.log("parte la chiamata della fetch!");
      await dispatch(handleRefreshToken(payload) as any);
    }
  };
  useEffect(() => {
    refresh();
    const interval = setInterval(() => {
      if (refreshToken && profilo) {
        handleRefreshToken({ email: profilo.email, refreshToken });
      }
    }, 40 * 60 * 1000);

    return () => clearInterval(interval);
  }, [refreshToken, profilo]);

  return (
    <AlertProvider>
      <Router>
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route path="/unauthorized" element={<Unauthorized />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route
            path="/home"
            element={
              <PrivateRoute>
                <Home />
              </PrivateRoute>
            }
          />
          <Route
            path="/eventi"
            element={
              <PrivateRoute>
                <Eventi />
              </PrivateRoute>
            }
          />
          <Route
            path="/cantieri"
            element={
              <PrivateRoute>
                <Cantieri />
              </PrivateRoute>
            }
          />
          <Route
            path="/committenti"
            element={
              <PrivateRoute>
                <Clienti />
              </PrivateRoute>
            }
          />
          <Route
            path="/contratti"
            element={
              <PrivateRoute>
                <Contratti />
              </PrivateRoute>
            }
          />
          <Route
            path="/calendario"
            element={
              <PrivateRoute>
                <CalendarioPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/scadenze"
            element={
              <PrivateRoute>
                <ScadenziarioPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/impostazioni"
            element={
              <PrivateRoute>
                <Impostazioni />
              </PrivateRoute>
            }
          />
          <Route
            path="/crea/:type"
            element={
              <PrivateRoute>
                <CreateEditPage action="crea" />
              </PrivateRoute>
            }
          />
          <Route
            path="/modifica/:type/:id"
            element={
              <PrivateRoute>
                <CreateEditPage action="modifica" />
              </PrivateRoute>
            }
          />
        </Routes>
      </Router>
    </AlertProvider>
  );
}

export default App;
